'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.getStateByModels = getStateByModels;
exports.getActionsByDispatch = getActionsByDispatch;
exports.setReducers = setReducers;
exports.getActions = getActions;
exports.getProcessorByExec = getProcessorByExec;
exports.getProcessorByGenerator = getProcessorByGenerator;
exports.getProcessor = getProcessor;

var _actionType = require('./actionType');

var _ajax = require('../utils/ajax');

var _ajax2 = _interopRequireDefault(_ajax);

var _isPlainObject = require('../core/isPlainObject');

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _isGenerator = require('./isGenerator');

var _isGenerator2 = _interopRequireDefault(_isGenerator);

var _messages = require('../core/messages');

var _messages2 = _interopRequireDefault(_messages);

var _warning = require('fbjs/lib/warning');

var _warning2 = _interopRequireDefault(_warning);

var _baseModel = require('../damo/baseModel');

var _baseModel2 = _interopRequireDefault(_baseModel);

var _reducerImmediate = require('./reducerImmediate');

var _reducerImmediate2 = _interopRequireDefault(_reducerImmediate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * bindings = ['model'], flattern = false
 * => {model: xxx}
 * bindings = ['model.state'], flattern = false
 * => {model: xxx}
 * bindings = ['model.actions'], flattern = false
 * => {model: xxx}
 * bindings = ['model.state.name'], flattern = false
 * => {model: xxx}
 * bindings = [{name: 'model.state.name'}], flattern = false|true
 * => {name: xxx}
 * bindings = [{name: {test: 1}}], flattern = false|true
 * => {name: {test: 1}}
 */
function getStateByModel(redux, binding, flattern, wrappers, attrKey) {
  var keys = binding.split('.');
  var modelName = keys.shift();
  attrKey = attrKey || modelName;
  var model = {
    state: redux.state[modelName] || {},
    actions: redux.actions[modelName] || {}
  };
  var iState = void 0;
  var wrapper = void 0;
  var name = void 0;
  var cate = keys[0];
  if (keys.length) {
    wrapper = wrappers[cate];
    if (wrapper) {
      iState = wrapper(model[keys.shift()]);
      name = keys.shift();
      while (name) {
        iState = iState[name];
        name = keys.shift();
      }
    } else if (!model[cate] && redux[cate]) {
      // support global function
      flattern = true;
      iState = (0, _defineProperty3.default)({}, cate, redux[cate].bind(null, modelName));
    }
  } else {
    iState = {};
    Object.keys(wrappers).forEach(function (name) {
      wrapper = wrappers[name];
      Object.assign(iState, wrapper(model[name]));
    });
  }
  if (flattern) {
    return iState;
  } else {
    return (0, _defineProperty3.default)({}, attrKey, iState);
  }
}

function getStateByModels(redux, bindings, flattern, wrappers, cacheMap) {
  var stateProps = {};
  var keys = void 0;
  var mState = void 0;
  try {
    bindings.forEach(function (binding) {
      if (typeof binding === 'string') {
        if (!cacheMap[binding]) {
          mState = getStateByModel(redux, binding, flattern, wrappers);
          if (mState && !mState[binding]) {
            cacheMap[binding] = true;
          }
        }
      } else {
        mState = {};
        for (var modelName in binding) {
          if (!cacheMap[modelName]) {
            if (Object(binding[modelName]) === binding[modelName]) {
              mState[modelName] = binding[modelName];
            } else if (typeof binding[modelName] === 'string') {
              Object.assign(mState, getStateByModel(redux, binding[modelName], false, wrappers, modelName));
            }
            if (mState[modelName] === undefined) {
              delete mState[modelName];
            } else {
              cacheMap[modelName] = true;
            }
          }
        }
      }
      Object.assign(stateProps, mState);
    });
  } catch (e) {
    (0, _warning2.default)(false, _messages2.default.selectError, 'select', keys, 'seed', 'Beatle');
    window.console.error(e);
  }
  return stateProps;
}

function getActionsByDispatch(actions, dispatch) {
  var actionCreators = {};

  var _loop = function _loop(name) {
    actionCreators[name] = function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var result = actions[name].apply(null, args);
      if (result && result.then) {
        return result;
      } else if (typeof result === 'function') {
        return result(dispatch);
      } else if (result !== undefined) {
        return dispatch(result);
      }
    };
  };

  for (var name in actions) {
    _loop(name);
  }
  return actionCreators;
}

function setReducers(model, modelName, actionName, actionCfg, async) {
  var callback = typeof actionCfg === 'function' ? actionCfg : actionCfg.reducer || actionCfg.callback || noop;
  var type = void 0;
  if (typeof callback === 'function') {
    type = async ? (0, _actionType.encodeActionType)(modelName, actionName, 'success') : (0, _actionType.encodeActionType)(modelName, actionName);
    model._reducers[type] = callback;
  } else {
    for (var status in callback) {
      if (typeof callback[status] === 'function') {
        type = (0, _actionType.encodeActionType)(modelName, actionName, status);
        model._reducers[type] = callback[status];
      }
    }
  }
}
/**
 * # action构建器
 *
 * + 参数1: option
 *  * modelName - 数据模型的实例名
 *  * model - 数据模型
 *  * resource - 要映射的接口资源
 * + 参数2: fetch
 *  * 接口调用模块，不强制依赖于ajax
 */
function getActions(_ref2, seed) {
  var modelName = _ref2.modelName,
      model = _ref2.model,
      resource = _ref2.resource,
      initialState = _ref2.initialState;

  var saga = seed._saga;
  var fetch = seed._ajax || new _ajax2.default();

  model.ACTION_TYPE_IMMEDIATE = (0, _actionType.encodeActionType)(modelName, '@@UPDATE_STATE');
  model._reducers = (0, _defineProperty3.default)({}, model.ACTION_TYPE_IMMEDIATE, function (nextStore, payload) {
    return (0, _reducerImmediate2.default)(nextStore, payload, modelName);
  });
  if (model.reducers) {
    for (var key in model.reducers) {
      model._reducers[(0, _actionType.encodeActionType)(modelName, key)] = model.reducers[key];
    }
  }
  /**
   * ### 数据模型内的副作用
   *
   * > 数据模型内副作用中callback、reducer兼容
   * > 跨数据模型副作用中subscriptions，externalReducers兼容
   */
  // 把reducers提前注入进去
  for (var actionName in model.reducers) {
    setReducers(model, modelName, actionName, { reducer: model.reducers[actionName] });
  }
  var subscriptions = model.subscriptions || model.externalReducers;
  var externalReducerKeys = Object.keys(subscriptions || {});
  /**
   * ### 跨数据模型之间的副作用
   *
   * ```
   *  const ModalA = {
   *    displayName: 'modelA',
   *    ...
   *    actions: {
   *      getUser: {
   *        exec,
   *        callback
   *      }
   *    }
   *  }
   *  const ModelB = {
   *    ...
   *    subscriptions: {
   *      'modelA.getUser.success': (modelB_nextStore, modelA_getUser_payload) => {
   *        // 返回值会更新到ModelB的store， 如果是promise那么会接受最终处理值
   *      }
   *    }
   *  }
   *  const ModelC = {
   *    ...
   *    subscriptions: {
   *      'modelA.getUser.success': (modelC_nextStore, modelA_getUser_payload) => {
   *        // 返回值会更新到ModelB的store
   *      }
   *    }
   *  }
   * ```
   */
  externalReducerKeys.forEach(function (rk) {
    var names = rk.split('.');
    var moduleName = names[0];
    var actionName = names[1];
    var statusName = void 0;
    var isAsyncAction = names.length === 3;
    if (isAsyncAction) {
      statusName = names[2];
    }
    var type = '';
    if (!isAsyncAction) {
      type = (0, _actionType.encodeActionType)(moduleName, actionName);
      model._reducers[type] = subscriptions[rk];
    } else {
      if (typeof subscriptions[rk] === 'function') {
        type = (0, _actionType.encodeActionType)(moduleName, actionName, statusName);
        model._reducers[type] = subscriptions[rk];
      } else if ((0, _typeof3.default)(subscriptions[rk]) === 'object') {
        var reducer = subscriptions[rk];
        for (var status in reducer) {
          if (typeof reducer[status] === 'function') {
            type = (0, _actionType.encodeActionType)(moduleName, actionName, status);
            model._reducers[type] = reducer[status];
          }
        }
      }
    }
  });

  var actions = model.actions || {};
  model.actions = {};
  model._actions = model._actions || {};
  if (model instanceof _baseModel2.default) {
    var keys = Object.getOwnPropertyNames(model.__proto__);
    for (var i = 1, len = keys.length; i < len; i++) {
      if (typeof model[keys[i]] === 'function') {
        model.actions[keys[i]] = model[keys[i]].bind(model);
      }
    }
  }

  // #! 大有用处：设置更新版本
  model.__setIncrement = function () {
    seed.increment();
  };
  model.effects = model.effects || {};

  Object.keys(actions).forEach(function (actionKey) {
    // 严格判断存在属性
    if (Object.prototype.hasOwnProperty.call(actions, actionKey)) {
      /**
       * ### action转为reducer后的执行逻辑
       *
       * action分2种，同步和异步的，区分取决于是否存在exec函数
       *
       * ```
       *  // 异步的action，在callback由3中状态的回调
       *  action = {
       *    exec,
       *    callback: {
       *      start,
       *      success,
       *      error
       *    }
       *  }
       *  // 同步action，callback及时回调函数
       *  action = {
       *    callback
       *  }
       * ```
       *
       * + 对于action调用时传参问题如何使用，可以参考下面同步action的使用（异步action也是如此）
       *
       * ```
       *  // 在组件中使用action
       *  this.props.action(1, 2);
       *  // action定义
       *  action = {
       *    callback: (nextStore, payload) => {
       *      // arguments = [1, 2];
       *      // payload = {data, arguments, type, store, message}
       *      nextStore.data = payload.arguments[0];
       *    }
       *  }
       * ```
       *
       * > payload是数据装载器，对于同步的action，data属性不会有值，data值只会接受异步action处理的结果值。arguments永远为action被调用时的传参
       */

      // 处理processor
      var actionCfg = actions[actionKey];
      if (actionCfg._processor) {
        return actionCfg._processor;
      }

      /**
       * ### Model联合Resource生成action
       *
       * 合并action的逻辑是：变量Resource，每个属性propName对应的值prop是一个接口调用配置或者函数，这个值会到Model.actions[propName]附加到exec属性中。并且都当做为异步action来处理
       *
       * ```
       *  // 异步步action，存在exec
       *  // 场景1：exec为接口配置
       *  {
       *    exec: {
       *      url,
       *      method,
       *      callback
       *    },
       *    calback: {
       *      start(){},
       *      success(){},
       *      error(){}
       *    }
       *  }
       *  // 场景1：exec为函数
       *  {
       *    exec: (data) => {
       *      return app.ajax({
       *        url: url,
       *        data: data.
       *        method: 'GET'
       *      })
       *    }
       *  }
       *  // 场景2： exec任意非纯对象
       *  {
       *    exec: Promise.resolve(1)
       *  }
       *  // 同步action
       *  {
       *   callback: (nextStore, payload) => {
       *   }
       *  }
       * ```
       *
       * > 实际上action的配置，只要存在exec属性，就认为是移动的action
       */
      var exec = actionCfg.exec || resource && resource[actionKey];
      if (exec) {
        // #! 异步action
        setReducers(model, modelName, actionKey, actionCfg, true);
        actionCfg._processor = model.actions[actionKey] = getProcessorByExec(model, initialState, modelName, actionKey, exec, fetch, exec.noDispatch);
      } else {
        setReducers(model, modelName, actionKey, actionCfg);
        if ((0, _isGenerator2.default)(actionCfg)) {
          model.effects[actionKey] = actionCfg;

          actionCfg._processor = model.actions[actionKey] = getProcessorByGenerator(model, initialState, modelName, actionKey, saga);
        } else {
          actionCfg._processor = model.actions[actionKey] = getProcessor(model, initialState, modelName, actionKey, actionCfg, function () {
            return seed.getStore().getState()[modelName];
          });
        }
      }
      Object.defineProperty(actions, actionKey, {
        get: function get() {
          return function () {
            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }

            return model.actions[actionKey].apply(model, args)(model.dispatch);
          };
        },
        enumerable: false
      });
    }
  });

  // 存在effect时走saga
  if (Object.keys(model.effects).length) {
    saga.effect(model);
  }

  return model.actions;
}

function noop() {}

function getProcessorByExec(model, initialState, modelName, actionName, exec, fetch, noDispatch) {
  return function () {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return function (dispatch) {
      if (args[args.length - 1] === false) {
        noDispatch = true;
        args.pop();
      }
      var statusMap = {
        start: (0, _actionType.encodeActionType)(modelName, actionName, 'start'),
        success: (0, _actionType.encodeActionType)(modelName, actionName, 'success'),
        error: (0, _actionType.encodeActionType)(modelName, actionName, 'error')
      };

      var promise = new Promise(function (resolve, reject) {
        var errorCallback = function errorCallback(error) {
          if (!noDispatch) {
            dispatch({ type: statusMap.error, error: true, payload: { data: undefined, store: initialState, arguments: args, message: error.message, exec: exec } });
          }
          reject(error);
        };
        var successCallback = function successCallback(data) {
          if (data instanceof Error) {
            errorCallback(data);
          } else {
            if (!noDispatch) {
              dispatch({ type: statusMap.success, payload: { data: data, store: initialState, arguments: args, exec: exec } });
            }
            resolve(data);
          }
        };

        var result = void 0;
        if (typeof exec === 'function') {
          result = exec.apply(model, args);
        } else if ((0, _isPlainObject2.default)(exec)) {
          // #! 保留之前的逻辑，这里是否继续优化
          var option = Object.assign({
            data: exec.data ? Object.assign({}, exec.data, args[0]) : args[0]
          }, args[1] || {});
          for (var key in option) {
            if (option[key] === undefined) {
              delete option[key];
            }
          }
          result = fetch.request(Object.assign({}, exec, option));
        } else {
          result = exec;
        }

        // #! is promise
        if (result && result.then) {
          result.then(successCallback, errorCallback);
        } else {
          successCallback(result);
        }

        return result;
      });
      // 添加一个promise，用于识别异步
      if (!noDispatch) {
        dispatch({ type: statusMap.start, payload: { data: undefined, store: initialState, arguments: args, exec: exec, promise: promise } });
      }

      return promise;
    };
  };
}

function getProcessorByGenerator(model, initialState, modelName, actionName, saga, noDispatch) {
  return function () {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return function (dispatch) {
      if (args[args.length - 1] === false) {
        noDispatch = true;
        args.pop();
      }
      if (noDispatch) {
        var _model$actions$action;

        return (_model$actions$action = model.actions[actionName]).apply.apply(_model$actions$action, [model].concat(args));
      } else {
        var actionKey = (0, _actionType.typeToAction)(modelName, actionName);
        dispatch({
          action: actionKey,
          payload: {
            arguments: args,
            store: initialState
          }
        });
        var type = (0, _actionType.encodeActionType)(modelName, actionName);
        return saga._getWatchPromise(type);
      }
    };
  };
}

function getProcessor(model, initialState, modelName, actionName, func, getState, noDispatch) {
  return function () {
    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    return function (dispatch) {
      if (args[args.length - 1] === false) {
        noDispatch = true;
        args.pop();
      }
      // 兼容之前副作用
      if (typeof func === 'function') {
        var isReducer = true;
        var showDispatch = function showDispatch(action) {
          if (!noDispatch) {
            dispatch(action);
            noDispatch = true;
          }
        };
        var newDispatch = function newDispatch(action) {
          isReducer = false;
          if (action.type) {
            var _decodeActionType = (0, _actionType.decodeActionType)(action.type),
                _decodeActionType2 = (0, _slicedToArray3.default)(_decodeActionType, 2),
                _modelName = _decodeActionType2[0],
                name = _decodeActionType2[1];

            if (!name || !model.actions[_modelName]) {
              // #! type指向model中的action
              action.type = (0, _actionType.encodeActionType)(_modelName, action.type);
            }
          } else {
            if (action.name) {
              if (action.name.indexOf('.') === -1) {
                action.name = (0, _actionType.typeToAction)(modelName, action.name);
              }
            } else {
              action = {
                type: model.ACTION_TYPE_IMMEDIATE,
                payload: action
              };
            }
          }
          showDispatch(action);
          return Promise.resolve(action.payload);
        };
        if (!noDispatch) {
          args = args.concat({
            put: newDispatch,
            select: function select(name, deep) {
              isReducer = false;
              var modelState = getState();
              (0, _warning2.default)(!modelState.hasOwnProperty || modelState.hasOwnProperty(name), _messages2.default.mergeWarning, 'select', name, modelName, 'Beatle.ReduxSeed');
              return Promise.resolve(modelState[name] && modelState[name].asMutable({ deep: deep }));
            }
          });
        }
        var result = func.apply(model, args);

        if (isReducer && result === undefined) {
          // #! 同步action
          dispatch({
            type: (0, _actionType.encodeActionType)(modelName, actionName),
            payload: {
              data: null,
              arguments: args,
              store: initialState
            }
          });
          return Promise.resolve(undefined);
        } else {
          if (result && result.then) {
            result.then(function (ret) {
              if (!(ret instanceof Error)) {
                showDispatch({
                  type: model.ACTION_TYPE_IMMEDIATE,
                  payload: ret
                });
              }
            }, function () {
              // handler
            });
            return result;
          } else {
            if (result) {
              showDispatch({
                type: model.ACTION_TYPE_IMMEDIATE,
                payload: result
              });
            }
            return Promise.resolve(result);
          }
        }
      } else if (noDispatch) {
        return Promise.resolve(func && func.data);
      } else {
        // #! 同步action
        dispatch({
          type: (0, _actionType.encodeActionType)(modelName, actionName),
          payload: {
            data: func ? func.data : null,
            arguments: args,
            store: initialState
          }
        });
        return Promise.resolve(undefined);
      }
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/seed/action.js
// module id = 33
// module chunks = 0